import { z } from 'zod';

// ── Marketplace event payloads ───────────────────────────────────────
// Minimal ids only — the worker rehydrates the full order snapshot from the DB.

export const OrderSentPayloadSchema = z.object({
    orderId: z.string().cuid2(),
    tenantId: z.string().cuid2(),
    vendorId: z.string().cuid2(),
});

export type OrderSentPayload = z.infer<typeof OrderSentPayloadSchema>;

export const VendorConnectedPayloadSchema = z.object({
    connectionId: z.string().cuid2(),
    tenantId: z.string().cuid2(),
    vendorId: z.string().cuid2(),
});

export type VendorConnectedPayload = z.infer<typeof VendorConnectedPayloadSchema>;

/**
 * A vendor's published T&C were edited, so every tenant signed at
 * `previousTermsVersion` is now blocked from sending until they re-sign. The
 * worker resolves the affected connections — the set is only knowable at
 * delivery time (AD-2298).
 */
export const VendorTermsUpdatedPayloadSchema = z.object({
    vendorId: z.string().cuid2(),
    termsVersion: z.number().int().positive(),
    previousTermsVersion: z.number().int().nonnegative(),
});

export type VendorTermsUpdatedPayload = z.infer<typeof VendorTermsUpdatedPayloadSchema>;
